import { Config } from './config-type'

export const config: Config = {
  SYSTEM_ENV: 'test',
  GTM_ID: 'GTM-WF6Q8GS',
}